export default __webpack_public_path__ + "static/media/graha-white-thin.07f85ee1.png";